/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Flex,
  Step,
  useSteps,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { SERVICE_POINT_INFORMATION } from "../constants";
import Loader from "../../../components/PageLoader";
import BreadCrumb from "../../../components/breadCrumb";
import { Paths } from "../../../routes/paths";
import {
  useAddLocation,
  useGetLocationSlaDefaultsByCustomerCity,
} from "../../../services/locations-apis";
import {
  useLookupCashCenters,
  useLookupCountries,
  useLookupCustomers,
  useLookupMachineMakers,
  useLookupMachineModel,
  useLookupMachineTypes,
} from "../../../services/lookups-mutations";
import { useLookupCurrency } from "../../../services/lookups-queries";
import Information from "./Information";
import SiteSLAs from "./site-SLAs";
import ServiceWindow from "./service-windows";
import SiteRepresentative from "./site-representative";
import Summary from "./summary";
import OnwardLocations from "./onwardLocations";
import Denominations from "./denominations";
import ScheduledService from "./scheduled-service";

const steps = [
  { title: "Information" },
  { title: "Onward Locations" },
  // { title: "Cassettes" },
  { title: "Denominations" },
  { title: "Timings" },
  // { title: "Models" },

  { title: "Representatives" },
  { title: "Scheduled Services" },
];
export default function AddServicePoint() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [servicePoint, setServicePoint] = useState({
    ...SERVICE_POINT_INFORMATION,
  });

  const {
    handleSubmit,
    control,
    watch,
    resetField,
    reset,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: { ...SERVICE_POINT_INFORMATION },
    mode: "onChange",
  });

  const navigate = useNavigate();

  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const params = useParams();
  const {
    mutate: getLocationSlaDefaults,
    isPending: gettingLocationSlaDefaults,
    data: locationSlaDefaultsRes,
  } = useGetLocationSlaDefaultsByCustomerCity();

  const [locationSlaDefaults, setLocationSlaDefaults] = useState(null);
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();

  const {
    mutate: getMachineTypes,
    data: machineListRes,
    isPending: gettingMachineList,
    // error: machineListError,
  } = useLookupMachineTypes();

  const {
    mutate: getMakersList,
    data: makersListRes,
    isPending: gettingMakersList,
    // error: makersListError,
  } = useLookupMachineMakers();
  const {
    mutate: getModelsList,
    data: modelsListRes,
    // isPending: gettingModelsList,
    // error: modelsListError,
  } = useLookupMachineModel();
  const {
    mutate: getCountries,
    data: countriesListRes,
    isPending: gettingCountriesList,
    // error: countriesListError,
  } = useLookupCountries();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useAddLocation();

  useEffect(() => {
    if (locationSlaDefaultsRes?.data) {
      setLocationSlaDefaults(locationSlaDefaultsRes.data);
    }
  }, [locationSlaDefaultsRes]);

  useEffect(() => {
    if (isRequestCreated) {
      setActiveStep(1);
      navigate(Paths.locations);
    }
  }, [isRequestCreated]);

  useEffect(() => {
    getCashCenter();
    getCustomers();
    getMachineTypes();
    getCountries();
    getMakersList();
  }, []);

  const fetchLocationSlaDefaults = (customerId, city) => {
    if (!customerId || !city) return;

    getLocationSlaDefaults({
      customerId,
      city,
    });
  };

  const addLocation = (data) => {
    createRequest(data);
  };
  const getServicePointInformation = useMemo(
    () => ({
      customerId: servicePoint.customerId,
      billingCustomerId: servicePoint.billingCustomerId,
      customerName: servicePoint.customerName,
      billingCustomerName: servicePoint.billingCustomerName,
      contractCode: servicePoint.contractCode,
      cashCenterId: servicePoint.cashCenterId,
      cashCenterName: servicePoint.cashCenterName,
      locationId: servicePoint.locationId,
      locationName: servicePoint.locationName,
      locationCode: servicePoint.locationCode,
      category: servicePoint.category,
      routeNo: servicePoint.routeNo,
      locationType: servicePoint.locationType,
      status: servicePoint.status,
      siteType: servicePoint.siteType,
      fixingSide: servicePoint.fixingSide,
      loadingSide: servicePoint.loadingSide,
      machineType: servicePoint.machineType,
      maker: servicePoint.maker,
      model: servicePoint.model,
      lockSerialNo: servicePoint.lockSerialNo,
      machineSerialNo: servicePoint.machineSerialNo,
      barcode: servicePoint.barcode,
      siteLimit: servicePoint.siteLimit,
      distanceFromBase: servicePoint.distanceFromBase,
      coLocatedGroupNo: servicePoint.coLocatedGroupNo,
      numberOfCassettes: servicePoint.numberOfCassettes,
      requiresCashierCount: servicePoint.requiresCashierCount,
      requiresEVhr: servicePoint.requiresEVhr,
      hasSecurityAlarm: servicePoint.hasSecurityAlarm,
      alarmDetails: servicePoint.alarmDetails,
      country: servicePoint.country,
      state: servicePoint.state,
      emirate: servicePoint.emirate,
      city: servicePoint.city,
      address: servicePoint.address,
      longitude: servicePoint.longitude,
      latitude: servicePoint.latitude,
      lockInstallationDate: servicePoint.lockInstallationDate,
      firstServiceDate: servicePoint.firstServiceDate,
      decomissionedDate: servicePoint.decomissionedDate,
      followStandardModels: servicePoint.followStandardModels,
      followStandardDenominations: servicePoint.followStandardDenominations,
      followStandardCassettes: servicePoint.followStandardCassettes,
      dedicatedSerials: servicePoint.dedicatedSerials,
      serviceDays: servicePoint.serviceDays,
      allowedDays: servicePoint.allowedDays,
      onwardLocations: servicePoint.onwardLocations,
      requestedBy: servicePoint.requestedBy || "",
      comments: servicePoint.comments || "",
      numberOfBins: servicePoint.numberOfBins || 0,
      numberOfKeys: servicePoint.numberOfKeys || 0,
      hasCamera: servicePoint.hasCamera || 0,
      cameraType: servicePoint.cameraType || "",
      area: servicePoint.area || "",
      machineInstallationDate:
        servicePoint.machineInstallationDate || new Date(),
    }),
    [servicePoint],
  );
  const updateServicePointInformation = (information) => {
    const _servicePoint = {
      customerId: information.customerId,
      billingCustomerId: information.billingCustomerId,
      customerName: information.customerName,
      billingCustomerName: information.billingCustomerName,
      contractCode: information.contractCode,
      cashCenterId: information.cashCenterId,
      cashCenterName: information.cashCenterName,
      locationId: information.locationId,
      locationName: information.locationName,
      locationCode: information.locationCode,
      category: information.category,
      routeNo: information.routeNo,
      locationType: information.locationType,
      status: information.status,
      siteType: information.siteType,
      fixingSide: information.fixingSide,
      loadingSide: information.loadingSide,
      machineType: information.machineType,
      maker: information.maker,
      model: information.model,
      lockSerialNo: information.lockSerialNo,
      machineSerialNo: information.machineSerialNo,
      barcode: information.barcode,
      siteLimit: information.siteLimit,
      distanceFromBase: information.distanceFromBase,
      coLocatedGroupNo: information.coLocatedGroupNo,
      numberOfCassettes: information.numberOfCassettes,
      requiresCashierCount: information.requiresCashierCount,
      requiresEVhr: information.requiresEVhr,
      hasSecurityAlarm: information.hasSecurityAlarm,
      alarmDetails: information.alarmDetails,
      country: information.country,
      state: information.state,
      emirate: information.emirate,
      city: information.city,
      address: information.address,
      longitude: information.longitude,
      latitude: information.latitude,
      lockInstallationDate: information.lockInstallationDate,
      firstServiceDate: information.firstServiceDate,
      decomissionedDate: information.decomissionedDate,
      followStandardModels: information.followStandardModels,
      followStandardDenominations: information.followStandardDenominations,
      followStandardCassettes: information.followStandardCassettes,
      dedicatedSerials: information.dedicatedSerials,
      serviceDays: information.serviceDays,
      allowedDays: information.allowedDays,

      numberOfBins: information.numberOfBins || 0,
      numberOfKeys: information.numberOfKeys || 0,
      hasCamera: information.hasCamera || 0,
      cameraType: information.cameraType || "",
      area: information.area || "",
      machineInstallationDate:
        information.machineInstallationDate || new Date(),
    };
    setServicePoint({ ...servicePoint, ..._servicePoint });
  };

  const updateOnwardLocations = (locations) => {
    setServicePoint({
      ...servicePoint,
      onwardLocations: locations,
    });
  };

  const getSiteSLAs = useMemo(() => {
    return Array.isArray(servicePoint.siteSLAs) ? servicePoint.siteSLAs : [];
  }, [servicePoint.siteSLAs]);
  const setSiteSLAs = (data) => {
    const slas = Array.isArray(data)
      ? data
      : Array.isArray(data?.SLAs)
        ? data.SLAs
        : [];

    setServicePoint((prev) => ({
      ...prev,
      siteSLAs: slas.map((sla) => ({
        serviceType: sla.serviceType,
        activityType: sla.activityType,
        responseTime: sla.responseTime,
        attendedTime: sla.attendedTime,
        resolutionTime: sla.resolutionTime,
      })),
      followsCustomerSla:
        typeof data?.followsCustomerSla === "boolean"
          ? data.followsCustomerSla
          : prev.followsCustomerSla,
    }));
  };

  const getServiceWindows = useMemo(() => {
    return Array.isArray(servicePoint.serviceWindows)
      ? servicePoint.serviceWindows
      : [];
  }, [servicePoint.serviceWindows]);
  const setServiceWindows = (data) => {
    setServicePoint((prev) => ({
      ...prev,
      followsCustomerServiceWindow:
        data?.followsCustomerServiceWindow ?? prev.followsCustomerServiceWindow,
      serviceWindows: Array.isArray(data?.serviceWindows)
        ? data.serviceWindows
        : [],
    }));
  };
  // const updateReplenishmentModels = (replenishmentModels) => {
  //   const _servicePoint = {
  //     ...servicePoint,
  //     replenishmentModels,
  //   };
  //   setServicePoint(_servicePoint);
  // };

  // const getReplenishmentModels = useMemo(
  //   () =>
  //     servicePoint.replenishmentModels.map((elm) => ({
  //       ...elm,
  //       expanded: false,
  //     })),
  //   [servicePoint],
  // );
  // const setCassettes = (cassettes) => {
  //   const _servicePoint = {
  //     ...servicePoint,
  //     cassettes,
  //   };
  //   setServicePoint(_servicePoint);
  // };

  // const getCassettes = useMemo(
  //   () => [...servicePoint.cassettes],
  //   [servicePoint],
  // );
  const setDenominations = (denominations) => {
    const _servicePoint = {
      ...servicePoint,
      denominations,
    };
    setServicePoint(_servicePoint);
  };

  const getDenominations = useMemo(
    () => [...servicePoint.denominations],
    [servicePoint],
  );
  const getSiteRepresentatives = useMemo(
    () => [...servicePoint.siteRepresentatives],
    [servicePoint],
  );

  const setSiteRepresentatives = (siteRepresentatives) => {
    const _servicePoint = {
      ...servicePoint,
      siteRepresentatives,
    };
    setServicePoint(_servicePoint);
  };

  const setScheduledServices = (data) => {
    const _servicePoint = {
      ...servicePoint,
      serviceSchedules: data,
    };
    setServicePoint(_servicePoint);
  };
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);
  return (
    <>
      {gettingCashCenterList ||
      creatingRequest ||
      gettingCustomerList ||
      gettingCountriesList ||
      gettingMakersList ||
      gettingCurrencyList ||
      gettingMachineList ||
      gettingLocationSlaDefaults ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Service Points", link: Paths.locations },
            { text: "Add Service Point", isCurrentPage: true },
          ]}
        />
        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                // if (activeStep === 1) {
                //   updateServicePointInformation(getValues());
                // }
                if (activeStep > 1) {
                  setActiveStep(index + 1);
                }
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>
        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  (params.locationId && servicePoint.locationId) ||
                  !params.locationId ? (
                    <form>
                      <Information
                        servicePointInformation={getServicePointInformation}
                        customerList={customerListRes?.data || []}
                        cashCenters={cashCenterList?.data || []}
                        makersList={makersListRes?.data || []}
                        machineList={machineListRes?.data || []}
                        countriesList={countriesListRes?.data || []}
                        editing={Boolean(params.locationId)}
                        isValid={isValid}
                        onMakerChange={(value) => {
                          if (value) {
                            setValue("maker", value);
                            getModelsList(value);
                          }
                        }}
                        handleSubmit={handleSubmit}
                        control={control}
                        errors={errors}
                        watch={watch}
                        onFetchSlaDefaults={fetchLocationSlaDefaults}
                        resetField={resetField}
                        setValue={setValue}
                        reset={reset}
                        getValues={getValues}
                        modelsList={modelsListRes?.data || []}
                        onNextStep={() => {
                          setActiveStep(2);
                          updateServicePointInformation(getValues());
                        }}
                      />
                    </form>
                  ) : (
                    <></>
                  )
                ) : activeStep === 2 ? (
                  <OnwardLocations
                    addedLocations={servicePoint.onwardLocations}
                    isValid={servicePoint?.onwardLocations?.length}
                    onAddLocations={updateOnwardLocations}
                    onNextStep={() => {
                      setActiveStep(3);
                    }}
                    onPrevStep={() => {
                      setActiveStep(1);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <Denominations
                    currencies={currencyListRes?.data || []}
                    disabled={watch("followStandardDenominations")}
                    followStandardDenominations={watch(
                      "followStandardDenominations",
                    )}
                    toggleStandardDenominations={() => {
                      const _value = !watch("followStandardDenominations");
                      setValue("followStandardDenominations", _value);
                    }}
                    denominations={getDenominations}
                    onNextStep={(denominations) => {
                      setActiveStep(4);
                      setDenominations(denominations);
                    }}
                    onPrevStep={(denominations) => {
                      setActiveStep(2);
                      setDenominations(denominations);
                    }}
                    addData={(data) => {
                      setDenominations(data);
                    }}
                    isValid={isValid}
                  />
                ) : activeStep === 4 ? (
                  <>
                    <ServiceWindow
                      initialServiceWindows={getServiceWindows}
                      locationSlaDefaults={locationSlaDefaults}
                      initialFollowsCustomerServiceWindow={
                        servicePoint.followsCustomerServiceWindow
                      }
                      addData={setServiceWindows}
                      onPrevStep={() => setActiveStep(3)}
                      onNextStep={() => setActiveStep(5)}
                    />

                    <SiteSLAs
                      initialSLAs={getSiteSLAs}
                      locationSlaDefaults={locationSlaDefaults}
                      initialFollowsCustomerSla={
                        servicePoint.followsCustomerSla
                      }
                      addData={setSiteSLAs}
                      onPrevStep={(data) => {
                        setSiteSLAs(data);
                        setActiveStep(3);
                      }}
                      onNextStep={(data) => {
                        setSiteSLAs(data);
                        setActiveStep(5);
                      }}
                    />
                  </>
                ) : activeStep === 5 ? (
                  <SiteRepresentative
                    siteRepresentatives={getSiteRepresentatives}
                    onNextStep={(siteRepresentatives) => {
                      setSiteRepresentatives(siteRepresentatives);
                      setActiveStep(6);
                    }}
                    onPrevStep={(siteRepresentatives) => {
                      setActiveStep(4);
                      setSiteRepresentatives(siteRepresentatives);
                    }}
                    addData={(data) => {
                      setSiteRepresentatives(data);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <ScheduledService
                    cashCenterId={servicePoint?.cashCenterId}
                    serviceSchedules={servicePoint.serviceSchedules}
                    onNextStep={(data) => {
                      setActiveStep(7);
                      setScheduledServices(data);
                    }}
                    onPrevStep={(data) => {
                      setActiveStep(5);
                      setScheduledServices(data);
                    }}
                    addData={(data) => {
                      setScheduledServices(data);
                    }}
                  />
                ) : activeStep === 7 ? (
                  <Summary
                    servicePoint={servicePoint}
                    onAddServicePoint={(data) => {
                      addLocation(data);
                    }}
                    editing={false}
                    onPrevStep={() => {
                      setActiveStep(6);
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
